import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import { validate } from "./helper"

const formSchema = {
  firstStep: [
    {
      id: 1333333333332323,
      name: "email",
      type: "email",
      required: true,
      label: "auth-email",
      placeholder: "enter-email-for-verify",
    },
  ],
  secondStep: [
    {
      id: 1,
      name: "code",
      type: "number",
      required: true,
      maxLength: 6,
      label: "auth-code",
      placeholder: "verify-with-email",
    },
    {
      id: 12333232,
      name: "password",
      type: "password",
      required: true,
      label: "auth-password",
      placeholder: "enter-new-password",
    },
  ],
}

const Forgot = ({
  actions: { showPass, setShowPass, handleVerification, step },
  fields,
}) => {
  const { t } = useTranslation()
  const [error, setError] = useState(false)

  const handleForm = () => {
    let isValidForm = true
    formSchema[step].forEach((element) => {
      if (element.required && !fields[element.name].value) {
        isValidForm = false
      }
    })
    if (isValidForm) {
      handleVerification({ ...fields }, step)
    } else {
      console.log("error submit")
      setError(() => true)
    }
  }

  const formCreator = (field) => {
    switch (field.type) {
      // case "text":
      //   return (
      //     <label className="block mb-4">
      //       <p className="mb-2 text-white font-semibold leading-normal">
      //         {t(`${field?.label}`)}
      //         <span className="text-red-500 mx-2">
      //           {error &&
      //             t(
      //               validate({ [field?.name]: fields[field?.name]?.value })
      //                 .errors[field?.name]
      //             )}
      //           *
      //         </span>
      //       </p>
      //       <input
      //         {...fields[field?.name]}
      //         className="px-4 py-3.5 w-full text-gray-400 font-medium placeholder-gray-400 bg-white outline-none rounded-xl border border-[#B3B3B3] outline-offset-0 focus:border-[var(--custom-secondary)] "
      //         type={field?.type}
      //         autoComplete="off"
      //         id="text"
      //       />
      //       <p>{t(`${field?.placeholder}`)}</p>
      //     </label>
      //   )
      case "number":
        return (
          <label className="block mb-4">
            <p className="mb-2 text-white font-semibold leading-normal">
              {t(`${field?.label}`)}
              <span className="text-red-500 mx-2">*</span>
            </p>
            <input
              {...fields[field?.name]}
              className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
              // type={field?.type}
              type="number"
              autoComplete="off"
              max={field?.maxLength}
              id="text"
            />
            <p className="text-red-500 mx-2 h-10">
              {error &&
                t(
                  validate({ [field?.name]: fields[field?.name]?.value })
                    .errors[field?.name]
                )}
            </p>
            <p>{t(`${field?.placeholder}`)}</p>
          </label>
        )
      case "email":
        return (
          <label className="block mb-4 ">
            <p className="mb-2 text-white font-semibold leading-normal">
              {t(`${field?.label}`)}
              <span className="text-red-500 mx-2">*</span>
            </p>
            <input
              {...fields[field?.name]}
              className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
              type={field?.type}
              autoComplete="off"
              id="email"
            />
            <p className="text-red-500 mx-2 h-10">
              {t(
                validate({ [field?.name]: fields[field?.name]?.value }).errors[
                  field?.name
                ]
              )}
            </p>
            <p>{t(`${field?.placeholder}`)}</p>
          </label>
        )
      case "password":
        return (
          <>
            <label className="block relative">
              <p className="mb-2 text-white font-semibold leading-normal">
                {t(`${field?.label}`)}
                <span className="text-red-500 mx-2">
                  {error &&
                    t(
                      validate({ [field?.name]: fields[field?.name]?.value })
                        .errors[field?.name]
                    )}
                  *
                </span>
              </p>
              <input
                {...fields[field?.name]}
                className="px-4 py-3.5 w-full text-gray-400 font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 invalid:border-red-500 invalid:text-red-600 focus:invalid:border-red-500 focus:invalid:ring-red-500 focus:bg-gray-700 focus:border-[rgba(255,255,255,0.8)]"
                id="signInInput1-2"
                type={showPass ? "text" : "password"}
                autoComplete="new-password"
              />
              <button
                type="button"
                onClick={() => setShowPass((prev) => !prev)}
                className="absolute top-[55%] right-3 text-disabled-text-color"
              >
                {showPass ? (
                  <AiOutlineEye size={24} color={"var(--custom-secondary)"} />
                ) : (
                  <AiOutlineEyeInvisible size={24} />
                )}
              </button>
            </label>
            <p className="text-red-500 mx-2 h-10">
              {t(
                validate({ [field?.name]: fields[field?.name]?.value }).errors[
                  field?.name
                ]
              )}
            </p>
            <p>{t(`${field?.placeholder}`)}</p>
          </>
        )
    }
  }

  return (
    <div className="lg:p-16 md:p-10 sm:p-10 p-10 xxl:p-24 flex flex-col justify-center">
      <h4 className="text-center text-xl font-medium mb-6">
        {t("auth-forgot")}
      </h4>
      <div className="w-full mx-auto" autoComplete="off">
        <div className="w-full mx-auto flex flex-col text-white">
          {formSchema[step]?.map((field) => {
            return <div key={field.id}>{formCreator(field)}</div>
          })}
        </div>
        <div className="flex justify-between items-center gap-4 py-4">
          <button
            className="pt-5 py-4 px-9 w-full text-white font-semibold border  rounded-xl shadow-4xl hover:bg-gray-700 transition ease-in-out duration-200"
            type="button"
            onClick={handleForm}
          >
            {t("auth-send-btn")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Forgot
